import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Image, Row } from "react-bootstrap";
import { AiFillCheckCircle } from "react-icons/ai";
import CardBasic from "../../../../../components/Card/card.basic";
import InstructorService from "../../../../../services/instructor.service";
import { AdminService } from "../../../../../services/admin.service";
import toast from "react-hot-toast";
import InstructorDetailModal from "./InstructorDetail.modal";

interface IInstructorDetails {
  instructor: any;
  getDetails:any;
  title?: string;
  isEnrollment?: boolean;
}

const InstructorDetail = (props: IInstructorDetails) => {
  const [show, setShow] = useState<boolean>(false);


  const handleToggle = async (toggle_id: any) => {
    await AdminService.toggleBlock(toggle_id)
      .then((res) => {
        if (res.status === 200) {
          console.log(res);

          toast.success("Updated ");
          props.getDetails();
        }
      })
      .catch((err: any) => {
        toast.error("Unable to Update Student Detail");
      });
  };

  return (
    <>
      <CardBasic
        body={
          <>
            {props.isEnrollment && (
              <div className="d-flex justify-content-start fw-bold fs-grey fs-14 mb-2">
                {props.title}
              </div>
            )}
            <div className="d-flex justify-content-start">
              <div>
                <Image
                  src={props.instructor.avatar}
                  height="150px"
                  width="150px"
                  className="rounded"
                />
              </div>
              <div className="ms-3 w-100">
                <div className="d-flex justify-content-between">
                  <span className="fw-bold fs-grey fs-14">
                    {props.instructor.firstName + " " + props.instructor.lastName}{" "}
                    <AiFillCheckCircle className="text-success" />
                    <div className="fs-12 fs-dhunprimary">
                      {props.instructor.email}
                    </div>
                  </span>
                  <span className="fs-grey fs-10 fw-bold">
                    {props.instructor._id}
                  </span>
                </div>
                <div className="mt-3 fs-14">
                  <h6 className="fs-grey"> Basic Details</h6>
                  <div className="bg-muted fs-12 w-100 rounded p-2">
                    <Row className="font-italic-imp">
                      <Col sm={6}>
                        Gender: {props.instructor.gender || "N.A."}
                        <br />
                        Email:{" "}
                        {props.instructor.isEmailConfirm
                          ? "Verified"
                          : "Not Verified"}
                        <br />
                        Source:{" "}
                        {props.instructor.utms
                          ? props.instructor.utms.utm_source +
                            " " +
                            props.instructor.utms.utm_campaign
                          : "N.A."}
                      </Col>
                      <Col sm={6}>
                        Star Teacher: {props.instructor.hasTakenDemo ? "Yes" : "No"}
                        <br />
                        <div className="d-flex flex-row gap-2">
                          Blocked:
                          <Form>
                            <Form.Check
                              type="switch"
                              id="toggle-switch"
                              checked={props.instructor.isBlocked}
                              onClick={() => handleToggle(props.instructor._id)}
                            />
                          </Form>
                          {props.instructor.isBlocked ? (
                            <Badge bg="danger">Blocked</Badge>
                          ) : (
                            <></>
                          )}
                        </div>
                        <br />
                        Phone: {props.instructor?.countryCode}{" "}
                        {props.instructor.phone || "N.A."}
                      </Col>
                      <Col>
                        <Button onClick={() => setShow(true)}>Edit</Button>
                      </Col>
                    </Row>
                    <br />
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </>
        }
      />

      <InstructorDetailModal
        show={show}
        handleClose={() => setShow(false)}
        reload={props.getDetails}
        instructor={props.instructor}
      />
    </>
  );
};

export default InstructorDetail;
